// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__kqhSm","description":"MealItem_description__HaYhd","price":"MealItem_price__e+Uwb"};